"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distanceSquares = exports.distance = void 0;
const distance = (p1, p2) => {
    if (p1.x === null || p1.y === null || p2.x === null || p2.y === null) {
        return Infinity;
    }
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
};
exports.distance = distance;
// Est ce que distance est inférieure ou égale à distance
const distanceSquares = (p1, p2, distance) => {
    if (p1.x === null || p1.y === null || p2.x === null || p2.y === null) {
        return false;
    }
    return Math.abs(p1.x - p2.x) <= distance && Math.abs(p1.y - p2.y) <= distance;
};
exports.distanceSquares = distanceSquares;
